import Vue from 'vue'
import {api} from '@/store/resources'
import {i18n} from "@/i18n"

export default {
    namespaced: true,
    state: {
        accounts: {
            data: [],
            capitalization: 0,
            dirty: true,
        },
        accounts_archived: {
            data: []
        },
        account_groups: {
            data: [],
            dirty: true,
            user_preferences: {
                dashboard_acc_groups_collapsed: JSON.parse(localStorage.getItem('dashboard_acc_group_collapsed')) || {}
            }
        },
    },
    getters: {
        accounts_balance: (state, getters, rootState) => {
            let sum = state.accounts.capitalization;
            sum = sum.toFixed(rootState.space.current_space.data.currency.decimals || 2).toString();
            sum = sum.split('.');
            sum[0] = sum[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ")
            sum = sum.join('.');
            return sum;
        },
        accounts_not_hidden: (state) => {
            return [...state.accounts.data].filter(acc => !acc.is_hidden)
        },
        accounts_sorted_in_space: (state, getters, rootState) => {
            let sortType = rootState.space.current_space.data.account_sort_type,
                accounts = [...state.accounts.data];
            return accounts.sort((a, b) => sortType !== 1 ? +b.balance_base - +a.balance_base : a.order - b.order)
        },
        account_groups_sorted: (state) => [...state.account_groups.data].sort((a, b) => a.order - b.order),
        accounts_by_groups: (state, getters) => {
            let groups = [...getters.account_groups_sorted],
                accounts = [...getters.accounts_sorted_in_space];
            return groups.map(item => ({...item, childs: accounts.filter(acc => acc.group_id === item.id)}));
        },
        accounts_by_groups_not_hidden: (state, getters) => {
            return getters.accounts_by_groups.map(item => {
                return {...item, childs: item.childs.filter(child => !child.is_hidden)};
            });
        },
        displayAccountsInGroups: (state, getters) => {
            return !!getters.accounts_by_groups.length;
        }
    },
    actions: {
        //accounts
        async getAccounts({commit, rootState, state}) {
            try {
                if (state.accounts.data.length === 0) {
                    commit('setAccountsDirty')
                }
                const space_id = rootState.space.current_space.data.id;
                const res = await api.accounts.get({space_id});
                if (res.body.success) {
                    commit('setAccounts', {
                        data: res.body.data,
                        sort_by: rootState.space.current_space.data.account_sort_type
                    });
                }
            } catch (e) {
                console.log(e)
            }
        },
        createAccount({commit}, data) {
            return api.accounts.save(data);
        },
        updateAccount({}, data) {
            return api.accounts.update({id: data.id}, {...data});
        },
        updateAccountsOrder({commit, dispatch, rootState}, {list, group_id}) {
            const space_id = rootState.space.current_space.data.id;
            let order = {};
            list.forEach((item, o) => {
                commit('updateAccountOrder', {...item, order: o, group_id: group_id});
                order[item.id] = o;
                //check if acc changed group
                if (group_id !== item.group_id) {
                    dispatch('updateAccount', {...item, group_id: group_id});
                }
            });
            api.accountsUpdateOrder.save({space_id, order});
        },
        archiveAccount({}, data) {
            return api.accounts.remove({id: data.id}, {delete_transactions: data.delete_transactions});
        },

        //account-groups
        createAccountGroup({commit}, data) {
            return api.account_groups.save(data);
        },
        async getAccountGroups({commit, rootState, state}) {
            try {
                if (state.account_groups.data.length === 0) {
                    commit('setAccountGroupsDirty')
                }
                const space_id = rootState.space.current_space.data.id;
                const res = await api.account_groups.get({space_id});
                if (res.body.success) {
                    commit('initGroups', res.body.data.rows);
                }
            } catch (e) {
                console.log(e)
            }
        },
        updateAccountGroup({commit}, data) {
            return api.account_groups.update({id: data.id}, {title: data.title});
        },
        updateAccountGroupsOrder({commit, rootState}, list) {
            const space_id = rootState.space.current_space.data.id
            let order = {};
            list.forEach((item, o) => {
                if (!!item.id) {
                    commit('updateAccountGroupOrder', item);
                    order[item.id] = o;
                }
            })
            api.accountGroupsUpdateOrder.save({space_id, order})
        },
        removeAccountGroup({commit}, id) {
            return api.account_groups.remove(id);
        },
    },
    mutations: {
        setAccountsDirty(state) {
            state.accounts.dirty = true
        },
        setAccountGroupsDirty(state) {
            state.account_groups.dirty = true
        },
        setAccounts(state, data) {
            let arr = data.data.rows;

            state.accounts.capitalization = data.data.capitalization;
            //sort_by === 1 - manual sorting by order
            //sort_by !== 1 - auto sorting by balance
            arr.sort((a, b) => data.sort_by !== 1 ? +b.balance_base - +a.balance_base : a.order - b.order);
            state.accounts.data = arr.filter(acc => acc.status === 1);
            //storing archived accounts separately to count space balance
            state.accounts_archived.data = arr.filter(acc => acc.status === 0);
            state.accounts.dirty = false;
        },

        initGroups(state, data) {
            let first = {
                    id: null,
                    title: i18n.locale === 'en' ? 'Without group' : 'Без группы',
                    order: 999,
                    sum: -10000000
                },
                arr = [first, ...data];

            arr.sort((a, b) => a.order - b.order);
            arr = arr.map(i => {
                return {
                    ...i,
                    dashboard_collapsed: state.account_groups.user_preferences.dashboard_acc_groups_collapsed[i.id] || false
                }
            })
            state.account_groups.data = arr;
            state.account_groups.dirty = false;
        },
        updateAccountOrder(state, data) {
            let accIndex = state.accounts.data.findIndex(account => account.id === data.id);
            Vue.set(state.accounts.data, accIndex, data);
        },
        updateAccountGroupOrder(state, data) {
            let groupIndex = state.account_groups.data.findIndex(group => group.id === data.id);
            Vue.set(state.account_groups.data, groupIndex, data);
        },
        //dashboard collapse mutation
        setGroupVisibility(state, data) {
            if (data.id === null) {
                return
            }
            state.account_groups.user_preferences.dashboard_acc_groups_collapsed[data.id] = data.state;
            state.account_groups.data =
                state.account_groups.data.map(i => i.id === data.id ? {...i, dashboard_collapsed: data.state} : {...i})
            localStorage.setItem('dashboard_acc_group_collapsed', JSON.stringify(state.account_groups.user_preferences.dashboard_acc_groups_collapsed))
        },
        clearAccounts(state) {
            state.accounts.data = [];
            state.accounts.dirty = true;
            state.account_groups.data = [];
            state.account_groups.dirty = true;
        }
    }
}
